import { Component } from "react"
import Popup from "../common/Popup"
import { showToast, TOAST_TYPE, DKButton, showLoader, removeLoader, DKIcons, DKLabel, DKIcon, DKSpinner, DKTooltipWrapper, DKInput, Toggle } from "deskera-ui-library";
import { empList, GEO_LOCATION_CONSTANT, GEO_LOCATION_MAPPING, NEW_GEO_LOCATION } from "./AttendanceSettingService";
import { INPUT_TYPE } from "deskera-ui-library";
import Utility from "../../utility/Utility";
import PayrollService from "../../services/PayrollService";
import MapPopup from "./AttendanceMap";
import AttendanceSettingApiService from "../../services/AttendanceSettingApiService";
import i18next from "i18next";
export default class AddNewGeoFencingPopup extends Component {
    canValidate = false;
    geoLocationForm = NEW_GEO_LOCATION;
    geoFencingData = {
        user: [],
        applicableToAll: GEO_LOCATION_CONSTANT.isApplicableTOAll,
        active: GEO_LOCATION_CONSTANT.active,
        radius: GEO_LOCATION_CONSTANT.defaultRadius,
        address: "",
        longitude: '',
        latitude: ''
    }
    employeeListOption = [];
    isLocationPopup = {
        visible: false
    }
    locationListOption = []
    constructor(props) {
        super(props)
        if(this.props && this.props.locationConfig) {
            this.geoLocationForm = this.geoLocationForm.filter(field=>(field.columnCode !== "user" && field.columnCode != "applicableToAll" && field.columnCode != "location"))
        } else {
            this.geoLocationForm = GEO_LOCATION_MAPPING;
            if ((empList && empList.length != 0)) {
                this.employeeListOption = empList;
                this.setOptionToField()
            } else {
                this.getUsers()
            }
            this.getLocation()
        }

    }
    componentDidMount() {
        this.updateFields()
        this.setState({
            ...this.state
        })
    }
    updateState() {
        this.setState({
            ...this.state
        })
    }
    updateFields() {
        this.geoLocationForm.forEach(field => {
            switch (field.columnCode) {
                case "user":
                    field.uiVisible = !this.geoFencingData?.applicableToAll?.id;
                    break;
            }
        })
    }
    setOptionToField() {
        let ind = this.geoLocationForm.findIndex(field => field.key === "user");
        if(ind !== -1) {
            this.geoLocationForm[ind].options = this.employeeListOption;
        }
    }
    getUsers() {
        PayrollService.getUsersList().then((res) => {
            if (res && res.users) {
                this.employeeListOption = res.users;
                this.setOptionToField()
                this.updateState()

            }
        });
    }
    getLocation() {
        this.locationListOption = this.props.geoLocations ? this.props.geoLocations : []
        this.locationListOption = this.locationListOption?.filter(loc=>loc.active);
        let ind = this.geoLocationForm.findIndex(field => field.key === "locations");
        if (ind !== -1) {
            this.geoLocationForm[ind].options = this.locationListOption;
        }
        this.updateState()

    }
    onClose=()=> {
        if (this.props.onClose) {
            this.props.onClose()
        }
    }
    validateForm() {
        let isValid = true;
        this.canValidate = true;
        this.geoLocationForm.forEach(field => {
            if (field.uiVisible && field.required && field.type != INPUT_TYPE.NUMBER && field.type != "button" && Utility.isEmpty(this.geoFencingData[field.key])) {
                isValid = false;
            } else if (field.uiVisible && field.required && field.type == INPUT_TYPE.NUMBER && field.type != "button" && Utility.isEmpty(this.geoFencingData[field.key].toString())) {
                isValid = false;
            } else if(field.columnCode === "address" && this.props?.locationConfig && this.geoFencingData && Utility.isEmpty(this.geoFencingData["placeId"])) {
                isValid = false;
            } else if (field.uiVisible && !field.isValid) {
                isValid = false;
            }
        })
        this.updateState();
        return isValid
    }
    onSave() {
        if (!this.validateForm()) {
            return;
        }
        if(this.props.locationConfig && (!this.geoFencingData || (Utility.isEmpty(this.geoFencingData.name) || Utility.isEmpty(this.geoFencingData.address)))) {
            return
        }
        let obj = {}
        if(this.props.locationConfig) {
            obj = {
                ...this.geoFencingData,
                name:this.geoFencingData?.name ? this.geoFencingData?.name.trim():"",
                address:this.geoFencingData?.address ? this.geoFencingData?.address.trim():"",
                active: this.geoFencingData?.active?.id ? true : false,
                radius: this.geoFencingData?.radius ? parseFloat(this.geoFencingData?.radius?.toString().trim()) : 0,
                latitude: this.geoFencingData?.latitude ? (this.geoFencingData?.latitude?.toString().trim()) : "0",
                longitude: this.geoFencingData?.longitude ? (this.geoFencingData?.longitude?.toString().trim()) : "0",
                placeId: this.geoFencingData?.placeId ? (this.geoFencingData.placeId) : ""
            }
            delete obj['user'];
            delete obj['applicableToAll']
        } else {
            obj = {
                applicableToAll: this.geoFencingData?.applicableToAll?.id ? true : false,
                active: this.geoFencingData?.active?.id ? true : false,
                iamUserIds: this.geoFencingData?.user?.map(ind => this.employeeListOption[ind].iamUserId),
                locationIds: this.geoFencingData?.locations?.map(ind => this.locationListOption[ind].id),
            }
        }
        obj = { geolocations: [obj] }
        if (obj) {
            showLoader()
            if(this.props.locationConfig) {
                AttendanceSettingApiService.saveAttendanceSetting(obj).then(res => {
                    removeLoader()
                    showToast(i18next.t("REC_UPDATE_SUCCESS"), TOAST_TYPE.SUCCESS)
                    if (this.props.onClose) {
                        this.props.onClose(true)
                    }
                }, error => {
                    removeLoader()
                    if(error && error.message && error.message.includes('already exists')) {
                        showToast(error.message, TOAST_TYPE.FAILURE)
                    } else {
                        showToast(i18next.t("REC_UPDATE_FAIL"), TOAST_TYPE.FAILURE)
                    }
                })
            } else {
                AttendanceSettingApiService.saveMapping(obj).then(res => {
                    removeLoader()
                    showToast(i18next.t("REC_UPDATE_SUCCESS"), TOAST_TYPE.SUCCESS)
                    if (this.props.onClose) {
                        this.props.onClose(true)
                    }
                }, error => {
                    removeLoader()
                    showToast(i18next.t("REC_UPDATE_FAIL"), TOAST_TYPE.FAILURE)
                })
            }

        }
    }
    formButtonClick() {
        this.onMapToggle()
    }
    onMapToggle(data) {
        this.isLocationPopup.visible = !this.isLocationPopup.visible;
        if (data && data.length !== 0) {
            this.geoFencingData['latitude'] = data[0].lat;
            this.geoFencingData['longitude'] = data[0].lng;
            this.geoFencingData['address'] = data[0].address ? data[0].address : "";
            this.geoFencingData['placeId'] = data[0].placeId ? data[0].placeId : "";
        }
        this.updateState()
    }
    onChange(value, index, obj) {
        switch (obj.key) {
            case "applicableToAll":
                this.geoFencingData[obj.key] = value;
                this.updateFields()
                break;
            default:
                this.geoFencingData[obj.key] = value;
                break;
        }
        this.updateState()
    }
    getFieldValue(obj) {
        switch (obj.columnCode) {
            default:
                return this.geoFencingData[obj.columnCode]
        }

    }
    renderFormButton(obj, index) {
        return (
            <div className="row row-responsive justify-content-between align-items-start position-relative p-v-s mb-r">
                <div className="mr-l ">
                    <DKLabel className="row-auto-width mb-xs dkinput-header-section mt-r" text={`${obj.name}`} />
                </div>
                <div className="column   dkinput-value-section ">
                    <DKButton icon={DKIcons.ic_location} title={obj.name ? obj.name : "Click"} className="text-app pl-0 fw-m" onClick={() => { this.formButtonClick() }} />
                </div>
            </div>
        )
    }
    renderFormField(obj, index) {
        return (
            <>
                <DKInput
                    className={"p-v-s mb-r"}
                    icon={obj.icon}
                    title={obj.name}
                    placeholder={obj.name}
                    value={this.getFieldValue(obj)}
                    options={obj.options}
                    type={obj.type}
                    errorMessage={(!Utility.isEmpty(this.getFieldValue(obj))&& obj.errorMessage) ? obj.errorMessage:null}
                    labelClassName=" text-align-left "
                    canValidate={this.canValidate}
                    onChange={(value) => {
                        this.onChange(value, index, obj);
                    }}
                    tooltip = {{
                        "content" : obj.tooltip,
                        "className" : "warning-tooltip-prop"
                    }}
                    displayKey="name"
                    validator={(value) => {
                        if (obj.validation && obj.validation.regExp) {
                            const regex = new RegExp(obj.validation.regExp);
                            obj.isValid = regex.test(value);
                            return regex.test(value);
                        } else if (obj.required && typeof value === "string" && Utility.isEmpty(value.trim())) {
                            obj.isValid = false
                            return false;
                        } else if (value && obj.required && obj.type == "number" && typeof value !== "number" && Utility.isEmpty(value.toString().trim())) {
                            obj.isValid = false
                            return false;
                        } else if (obj.required && Utility.isEmpty(value) && (obj.type != "number")) {
                            obj.isValid = false
                            return false;
                        } else if(obj.required && typeof value === "string" && obj.columnCode === "address" && !Utility.isEmpty(value) && this.geoFencingData && Utility.isEmpty(this.geoFencingData.placeId)) {
                             obj.isValid = false;
                             return false;
                        } else {
                            obj.isValid = true;
                            return true;
                        }
                    }}
                    formatter={(obj) => {
                        /** How to render a selected option in case of object **/
                        return obj.name;
                    }}
                    dropdownConfig={{
                        className: "",
                        style: {},
                        multiSelect: obj.multiSelect,
                        data: obj.options,
                        allowSearch:
                        obj.options && obj.options.length > 6 ? true : false,
                        searchableKey: "name",
                        renderer: (index, obj) => {
                            /** How to render value in Dropdown in case of object **/
                            return <DKLabel text={`${obj.name}`} />;
                        },
                        onSelect: (index, obj) => {

                        },
                    }}
                    direction={obj.direction}
                    required={obj.required}
                    readOnly={obj.readOnly}
                />
            </>
        )
    }
    formRender() {
        return (<>
            {this.geoLocationForm.map((obj, index) => {
                if (obj.type != "button") {
                    return (obj.uiVisible && (this.renderFormField(obj, index)))
                } else {
                    return this.renderFormButton(obj, index)
                }

            })}
        </>
        )
    }
    render() {
        return (
            <>
                <Popup popupClass={"popup-overflow"}>
                    <div className="row justify-content-between">
                        <DKLabel className="fw-m fs-l" text={(this.props && this.props.locationConfig) ? i18next.t("ADD_LOCATION"): i18next.t("ADD_EMP_LOCATION_MAPPING")} />
                        <div className="d-flex">
                            <DKButton title={i18next.t("SAVE")} className="bg-app  text-white " onClick={() => this.onSave()} />
                            <DKButton title={i18next.t("CANCEL")} className=" border-m bg-gray1  ml-m" onClick={() => this.onClose()} />
                        </div>
                    </div>
                    {this.formRender()}
                </Popup>
                {this.isLocationPopup.visible && <MapPopup data={this.isLocationPopup.data} onClose={(data => { this.onMapToggle(data) })} />}
            </>
        )
    }
}